import React from 'react';
import { OutlinedIcons } from '@marageti/z4-lib';
import { ReactComponent as MenuIcon } from '../../../assets/svg/menu.svg';
import styles from './mobile-button.module.scss';
import { MobileButtonProps } from '../types';

const { OutlinedXIcon } = OutlinedIcons;

const MobileButton = ({
  onClick,
  showMenu,
}: MobileButtonProps) => (
  <button
    type="button"
    aria-label={showMenu ? 'Close navigation menu' : 'Open navigation menu'}
    className={styles['mobile-button']}
    onClick={onClick}
  >
    <div className={styles['icon-wrapper']}>
      <MenuIcon className={`${styles['menu-icon']} ${!showMenu ? styles.visible : styles.hidden}`} aria-hidden />
      <OutlinedXIcon className={`${styles['close-icon']} ${showMenu ? styles.visible : styles.hidden}`} aria-hidden />
    </div>
  </button>
);

export default MobileButton;
